// @flow
import { connect } from 'react-redux'
import type { Dispatch } from 'redux'
import { withRouter } from 'next/router'
import BillingInformation from './BillingInformation'
import type { PropsType, DispatchPropsType } from './BillingInformation'
import type { AppStateType } from '../../../reducers/appstate'
import { subscribeAction } from '../../../actions/subscriptionActions'
import { userSubscriptionExpiring } from '../../../models/User'
import { isChurned } from './selectors'

type OwnPropsType = {
  headerText?: string,
  subHeaderText?: string,
  showBackAsCta?: boolean,
   router: {
    asPath: string
   }
}

const mapStateToProps = (state: AppStateType, ownProps: OwnPropsType): any => {
  const isExpiring = userSubscriptionExpiring(state.user)

  return ({
    isExpiring,
    isSubscribed: !!state.user.isSubscribed,
    inProcess: (state.subscriptionPurchase || {}).inProcess,
    userLoaded: state.userLoaded,
    plan: (state.subscriptionPurchase || {}).plan,
    error: (state.subscriptionPurchase || {}).error,
    subscribeText: (state.subscriptionText || {}).subscribeText || '',
    price: (state.subscriptionText || {}).price || '',
    trialDays: (state.subscriptionText || {}).trialDays || 0,
    successfulPurchase: (state.subscriptionPurchase || {}).isSuccessful,
    showBackAsCta: ownProps.showBackAsCta,
    promoValid: (state.subscriptionPromo || {}).valid,
    isChurned: isChurned(state)
  }: PropsType)
}

const mapDispatchToProps = (dispatch: Dispatch<any>): any => {
  return ({
    subscribe: (stripeObj: any, cardNumberElement?: any, altPaymentEvent?: any): void => dispatch(subscribeAction(stripeObj, cardNumberElement, altPaymentEvent, true))
  }: DispatchPropsType)
}

export default withRouter(connect < PropsType & DispatchPropsType, OwnPropsType, _, _, _, _ >(mapStateToProps, mapDispatchToProps)(BillingInformation))
